import { formatCount } from "@/lib/format";

/** Small counts as words, the way the greeting says them: "Seven matches". */
export function countWord(value: number): string {
    const words = [
        "No",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
    ];
    return words[value] ?? formatCount(value);
}

/** The time of day, for the greeting. */
export function greeting(hour: number): string {
    if (hour < 12) return "Morning";
    if (hour < 18) return "Afternoon";
    return "Evening";
}
